import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
    issuer: environment.auth.issuer,
    clientId: environment.auth.clientId,
    responseType: 'code',
    redirectUri: window.location.origin + "/auth/callback",
    logoutUrl: window.location.origin + "/auth/logout",
    scope: environment.auth.scope,
    timeoutFactor: 0.95,
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: environment.auth.showDebugInformation,
    sessionChecksEnabled: true,
    sessionCheckIntervall: 5 * 60 * 1000,
    useSilentRefresh: false
}